import React, { useMemo } from 'react';

import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { reduce } from 'lodash';
import { Link } from 'react-router-dom';
import Email from 'views/I9/components/Email';

import { CONTACT_PREFERENCES_LIST } from '../programme/Programme';

export const DetailsTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.lightGrey,
    color: theme.palette.primary.dark,
    maxWidth: 'none',
    border: '1px solid #707070',
    fontSize: '13px',
  },
}));

const PromoteurInfoCell = ({ values }) => {
  const isReservation = ['option'].includes(values.type);

  const contactPref = useMemo(() => {
    if (isReservation) {
      return values.prog?.contact_reservation_type;
    }

    return values.prog?.contact_denonce_type;
  }, [values.prog, isReservation]);

  const contactPrefString = useMemo(
    () =>
      reduce(
        contactPref,
        (acc, currentVal, index) => {
          if (currentVal === '1') {
            return [...acc, CONTACT_PREFERENCES_LIST[index]];
          }

          return acc;
        },
        [],
      ),
    [contactPref],
  );

  const email =
    contactPrefString.includes('Mail') &&
    (isReservation
      ? values.prog?.chargeReceptionsLots?.email_pro
      : values.prog?.responsableGestionFinanciere?.email_pro);

  return (
    <>
      <DetailsTooltip
        title={
          <div>
            <strong>Responsable vente :</strong> {values.prog?.promoteur?.responsable_vente}
            <br />
            <strong>Contact :</strong>
            <br />
            {contactPrefString.includes('Extranet') && values.prog?.promoteur?.site_internet && (
              <div>
                <div>
                  <strong>Extranet</strong>
                </div>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href={values.prog?.promoteur?.site_internet} target='_blank' rel='noopener noreferrer'>
                  {values.prog?.promoteur?.site_internet}
                </a>
                <br />
                <strong>Login extranet :</strong>
                &nbsp;{values.prog?.promoteur?.login_site_internet}
                <br />
                <strong>Mot de passe extranet :</strong>
                &nbsp;{values.prog?.promoteur?.mdp_site_internet}
              </div>
            )}
            {contactPrefString.includes('Mail') && (
              <div>
                <div>
                  <strong>Mail</strong>
                </div>
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            )}
            <br />
          </div>
        }
        interactive
      >
        <Link to={{ pathname: `/i9/promoteurs/${values.prog?.promoteur?.idpromoteur}` }}>
          {values.prog?.promoteur?.nom}
        </Link>
      </DetailsTooltip>{' '}
      <Email
        to={values.commercial?.email}
        subject={`[Immobilier-Neuf] Dénonce d'un client`}
        text={`Bonjour,\n\nNous souhaiterions dénoncer notre prospect ${values.client} sur votre programme ${values.prog?.nom} (${values.prog?.dept}) : ${values.prog?.adresse} - ${values.prog?.cp} ${values.prog?.ville}\n\nSans retour de votre part sous 48h, nous considèrerons cette dénonce comme acceptée.\n\nVous remerciant par avance de votre retour,\nBien cordialement`}
      >
        <span className={'nav-icon nav-icon-custom'}>
          <FontAwesomeIcon icon={faEnvelope} />
        </span>
      </Email>
    </>
  );
};

export default PromoteurInfoCell;
